import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersState } from './users.state';

export const selectUsersState = createFeatureSelector<UsersState>('users');

export const selectLoadedUsers = createSelector(selectUsersState, state => state.loadedUsersData);

export const selectForeignerBasicData = createSelector(selectUsersState, state => state.foreignerBasicData);

export const selectEmployeeBasicData = createSelector(selectUsersState, state => state.employeeBasicData);

export const selectLoadedPagination = createSelector(selectUsersState, state => state.loadedUsersPagination);

export const selectLoading = createSelector(selectUsersState, state => state.loading);

export const selectErrorMessage = createSelector(selectUsersState, state => state.errorMessage);

export const selectEmployeeTypes = createSelector(selectUsersState, state => state.employeeTypes);
export const selectAllRoles = createSelector(selectUsersState, state => state.allRoles);
export const selectLoadingEmployeeTypes = createSelector(selectUsersState, state => state.loadingEmployeeTypes);

export const selectReassignInProgress = createSelector(selectUsersState, state => state.reassignInProgress);

export const selectLoadingDataListingRequest = createSelector(
  selectUsersState,
  state => state.loadingDataListingRequest
);
export const selectDataListingRequests = createSelector(selectUsersState, state => state.dataListingRequests);
